<template>
  <div class="relative flex">
    <div class="box !p-0 box-25 last:mr-0 relative w-full device_small">
      <!-- <pre>{{ config }}</pre> -->

      <!-- <HMS :config="config" :classTpl="{
      div: 'cursor-pointer aspect-square absolute top-[45px] right-[6px] w-[26px]',
      svg: 'w-full'
    }" /> -->
      <Flight_Flight
        :config="config"
        v-if="Number.isInteger(config?.flight?.id)"
      />

      <!-- DOCK -->
      <template v-if="config?.dock?.id != undefined">
        <DockAlert :config="config" />
        <div class="flex">
          <DockSmallQuickStatus
            :config="config"
            size="w-[55px] min-w-[55px] max-w-[55px]"
          />

          <div class="flex w-full flex-wrap">
            <div class="px-2 py-2 w-full flex flex-col justify-around">
              <span class="text-balance">
                #{{ config.dock.id }} - {{ config.dock.name }}
              </span>

              <!-- Status -->
              <div class="flex items-center justify-between">
                <DockStatus :config="config" />
                <LastDockStatus :config="config" />
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- RC+ -->
      <template v-if="config?.rcPlus?.id != undefined">
        <div class="flex">
          <RcPlusSmallQuickStatus
            :config="config"
            size="w-[55px] min-w-[55px] max-w-[55px]"
          />
          <div class="flex w-full flex-wrap">
            <div class="px-2 py-2 w-full flex flex-col justify-around">
              <span class="text-balance">
                #{{ config.rcPlus.id }} - {{ config.rcPlus.name }}
              </span>
              <!-- Status -->
              <div class="flex items-center justify-between">
                <span class="w-full">
                  <RcPlusStatus :config="config" />
                </span>
                <div class="ml-2 flex">
                  <RcPlusLastStatus :config="config" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- DRONE -->
      <template v-if="config?.drone?.id != undefined">
        <div class="flex">
          <DroneSmallQuickStatus
            :config="config"
            size="w-[55px] min-w-[55px] max-w-[55px]"
          />

          <div class="flex border-t border-g2 w-full flex-wrap">
            <div class="px-2 py-2 w-full flex flex-col justify-around">
              <span class="text-balance">
                #{{ config.drone.id }} - {{ config.drone.name }}
              </span>
              <!-- Status -->
              <div class="flex items-center justify-between">
                <DroneStatus :config="config" />
                <LastDroneStatus :config="config" />
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-if="config?.parachute?.id != undefined">
        <div class="flex">
          <ParachuteSmallQuickStatus
            :config="config"
            size="w-[55px] min-w-[55px] max-w-[55px]"
          />


          <div class="flex border-t border-g2 w-full flex-wrap">
            <div class="px-2 py-2 w-full flex flex-col justify-around">
              <span class="text-balance">
                #{{ config.parachute.id }} - {{ config.parachute.name }}
              </span>
              <!-- Status -->
              <div class="flex items-center justify-between">
                <Parachute_FTS :config="config" />
                <Parachute_Status :config="config" />
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <Device_Link
      v-if="
        $root.user.can([4,5], 'DEVICES.EDIT.edit_device') &&
        config?.deviceFamilly?.this_dev_id != undefined &&
        deviceLink_active &&
        !$root.isMilestonePlugin
      "
      :dev_id="config.deviceFamilly.this_dev_id"
      CssClass="right-[45px]"
    />

    <div class="flex flex-col">
      <template v-if="$root.isMilestonePlugin">
        <div
          class="bg-g2 border-l-[6px] border-l-g0 cursor-pointer flex h-full items-center px-2 open_full only_full"
          @click="OpenPopupOnCurrentPage()"
          :class="{
            '!bg-flyingeye': config.deviceFamilly.this_dev_id == $route.params.dev_id,
          }"
        >
          <SVG name="doubleChevron" css="m-auto w-[10px] fill-current"></SVG>
        </div>
      </template>
      <template v-else>
        <div
          class="bg-g2 border-l-[6px] border-l-g0 cursor-pointer flex items-center mb-1 mb-2 px-2 open_popup"
          :class="{
            'only_popup' : !$root.user.can([1,2,3,4,5], 'DEVICES.open_full'),
          }"
          @click.stop.prevent="openPopup()"
          v-if="$root.user.can([1,2,3,4,5], 'DEVICES.open_popup')"
        >
          <SVG name="openPopup" css="fill-current w-[10px]"></SVG>
        </div>

        <div
          class="bg-g2 border-l-[6px] border-l-g0 cursor-pointer flex h-full items-center px-2 open_full"
          :class="{
            '!bg-flyingeye': config.infoType == 'full',
            'only_full' : !$root.user.can([1,2,3,4,5], 'DEVICES.open_popup')
          }"
          @click="goFull()"
          v-if="
            fullBtn &&
            $root.user.can([1,2,3,4,5], 'DEVICES.open_full')
          "
        >
          <SVG name="doubleChevron" css="m-auto w-[10px] fill-current"></SVG>
        </div>
      </template>
    </div>
  </div>

  <!-- <pre>{{ config }}</pre> -->
</template>

<script>
import SVG from "@/partials/SVG.vue";

import Device_Link from "@/partials/Device/Template/Device_Link.vue";
import Flight_Flight from "@/partials/Device/Template/Flight/Flight_Flight.vue";
// ---
import DockMap from "@/partials/Device/Template/Dock/DockMap.vue";
import DockAlert from "@/partials/Device/Template/Dock/DockAlert.vue";
import DockStatus from "@/partials/Device/Template/Dock/DockStatus.vue";
import DockSmallQuickStatus from "@/partials/Device/Template/Dock/DockSmallQuickStatus.vue";
import LastDockStatus from "@/partials/Device/Template/Dock/LastDockStatus.vue";
// ---
import RcPlusSmallQuickStatus from "@/partials/Device/Template/Rc+/RcPlusSmallQuickStatus.vue";
import RcPlusStatus from "@/partials/Device/Template/Rc+/RcPlusStatus.vue";
import RcPlusLastStatus from "@/partials/Device/Template/Rc+/RcPlusLastStatus.vue";
import RcPlusMap from "@/partials/Device/Template/Rc+/RcPlusMap.vue";
// ---
import DroneStatus from "@/partials/Device/Template/Drone/DroneStatus.vue";
import DroneSmallQuickStatus from "@/partials/Device/Template/Drone/DroneSmallQuickStatus.vue";
import LastDroneStatus from "@/partials/Device/Template/Drone/LastDroneStatus.vue";
import DroneMap from "@/partials/Device/Template/Drone/DroneMap.vue";
// ---
import ParachuteSmallQuickStatus from "@/partials/Device/Template/Parachute/ParachuteSmallQuickStatus.vue";
import Parachute_FTS from "@/partials/Device/Template/Parachute/Parachute_FTS.vue";
import Parachute_Status from "@/partials/Device/Template/Parachute/Parachute_Status.vue";
// ---
import Videos from "@/partials/Video/Videos.vue";

export default {
  name: "Device_Info_Small",
  props: {
    config: {
      type: Object,
      required: true,
    },
    deviceLink_active: {
      type: Boolean,
      default: true,
    },
    fullBtn: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    SVG,
    // --- Video
    Videos,
    Device_Link,
    Flight_Flight,
    // --- Dock
    DockMap,
    DockAlert,
    DockStatus,
    DockSmallQuickStatus,
    LastDockStatus,
    // --- Rc+
    RcPlusSmallQuickStatus,
    RcPlusStatus,
    RcPlusLastStatus,
    RcPlusMap,
    // --- Drone
    DroneStatus,
    DroneSmallQuickStatus,
    LastDroneStatus,
    DroneMap,
    // --- Parachute
    ParachuteSmallQuickStatus,
    Parachute_FTS,
    Parachute_Status,
  },

  methods: {
    openPopup() {
      this.config.methods.OpenPopup(
        this.config,
        this.video
      );
    },

    goFull() {
      if (this.config.infoType == "full") {
        this.config.dock.methods.ShowTheDock();
        return;
      } else {
        this.config.infoType = "full";
      }
    },

    OpenPopupOnCurrentPage(){
      this.config.methods.OpenPopupOnCurrentPage(
        this.config,
        this.video
      );
    }
  },
};
</script>
